import { RiSendPlaneFill } from "react-icons/ri";
import { FaUser } from "react-icons/fa6";

const ChatDemo = () => {
  return (
    <div className="w-[90%] md:max-w-[912px] h-[404px] flex flex-col relative">
      <img
        src="/media/images/landing-page/ai-bot.png"
        alt="chat_bot"
        className="h-[100px] w-[100px] top-[-30px] right-[-15px] md:h-[200px] md:w-[200px] absolute md:top-[-80px] md:right-[-78px] rotate-[-10deg]"
      />
      <div className="h-[47px] md:h-[64px] bg-primary-4 flex flex-start items-center gap-2 px-5">
        <img
          src="/media/images/landing-page/bot-icon-2.png"
          alt="chat_bot"
          className="w-[31px] w-[31px] md:w-[42px] md:h-[42px]"
        />
        <div className="text-white">Chat with me</div>
      </div>
      <div className="bg-primary-3 flex flex-col flex-1 py-3 md:py-5 px-4 md:px-8">
        <div className="flex-1 flex gap-3 flex-col flex-1">
          <div className="flex items-center gap-3">
            <img
              src="/media/images/landing-page/bot-icon-3.png"
              alt="chat_bot"
              className="w-[31px] w-[31px]"
            />
            <div className="border-2 border-[#2B3F23] h-[48px] flex px-3 items-center text-white">
              Hello, how can I assist you?
            </div>
          </div>
          <div className="flex items-center gap-3 justify-end">
            <div className="border-2 border-[#2B3F23] h-[48px] flex px-3 items-center text-white">
              Hello, how can I assist you?
            </div>
            <div className="min-h-[30px] min-w-[30px] rounded-full bg-primary-1 flex justify-center items-center">
              <FaUser className="text-white text-[16px]" />
            </div>
          </div>
        </div>
        <div className="relative">
          <textarea
            placeholder="Ask me anything... "
            className="h-[70px] bg-[#304528] p-2 w-full rounded-1 resize-none text-white"
            disabled
          />
          <RiSendPlaneFill className="text-primary-1 absolute right-4 top-4 text-[32px] rounded-sm" />
        </div>
      </div>
    </div>
  );
};

export default ChatDemo;
